import React, { useState, useEffect } from "react";
import PrimaryCrossSellStyle from "./primary";
import SecondaryCrossSellStyle from "./secondary";
import TertiaryCrossSellStyle from "./tertiary";

const Upsell = ({
  upsell, crossSellStyle, ecoPackage,
  setTotalPrice, totalPrice,
  totalCompareAtPrice, setTotalCompareAtPrice,
  crossSellVariants, setCrossSellVariants, type,
  addVariant, variantAdded, differencePrice
}) => {

  const [selectedVariant, setSelectedVariant] = useState(upsell);
  const handleVariantSelect = (variant) => setSelectedVariant(variant);

  useEffect(() => {
    if (upsell?.singleVariant != null) {
      setSelectedVariant(upsell?.singleVariant[0]);
    }
  }, [upsell]);

  const addVariantToCart = (variant) => {
    const variantId = variant?.id;
    const variantPrice = +variant?.store?.price;
    const variantCompareAtPrice = +variant?.store?.compareAtPrice;

    const variantAdded = type === "eco-package"
      ? ecoPackage[variantId]
      : crossSellVariants[variantId];

    const updatedTotalPrice = variantAdded
      ? totalPrice - variantPrice
      : totalPrice + variantPrice;
    setTotalPrice(updatedTotalPrice);

    const updatedTotalCompareAtPrice = variantAdded
      ? totalCompareAtPrice - variantCompareAtPrice
      : totalCompareAtPrice + variantCompareAtPrice;
    setTotalCompareAtPrice(updatedTotalCompareAtPrice);

    setCrossSellVariants((prevVariants) => {
      if (variantAdded) {
        // eslint-disable-next-line no-unused-vars
        const { [variantId]: _, ...restVariants } = prevVariants;
        return { ...restVariants };
      } else {
        return {
          ...prevVariants,
          [variantId]: variant
        };
      }
    });
  };

  const variantIsAdded = type == "eco-package" ? variantAdded : crossSellVariants[selectedVariant?.variant?.id];

  const CrossSellUIComponent = crossSellStyle === "secondary"
    ? SecondaryCrossSellStyle
    : crossSellStyle === "tertiary"
      ? TertiaryCrossSellStyle
      : PrimaryCrossSellStyle;

  const productLink=`/products/${selectedVariant?.variant?.store?.productHandle}/${selectedVariant?.variant?.variantHandle}`;
  
  if (upsell?.hideGiftPackage) return <></>;
  return (
    <CrossSellUIComponent
      upsell={upsell}
      crossSellStyle={crossSellStyle}
      setTotalPrice={setTotalPrice}
      totalPrice={totalPrice}
      totalCompareAtPrice={totalCompareAtPrice}
      setTotalCompareAtPrice={setTotalCompareAtPrice}
      crossSellVariants={crossSellVariants}
      setCrossSellVariants={setCrossSellVariants}
      variantIsAdded={variantIsAdded}
      addVariantToCart={addVariantToCart}
      handleVariantSelect={handleVariantSelect}
      selectedVariant={selectedVariant}
      addVariant={addVariant}
      type={type}
      differencePrice={differencePrice}
      productLink={productLink}
    />
  );
};

export default Upsell;
